import React from 'react'
import { motion } from 'framer-motion'
type AlignmentData = {
  corePriorities: string[]
  whatMatters: string[]
  flexibilitySnapshot: string[]
}
interface AlignmentSnapshotProps {
  data?: AlignmentData
}
const defaultData: AlignmentData = {
  corePriorities: ['Faith practice', 'Family values', 'Emotional maturity'],
  whatMatters: [
    'Building a partnership rooted in faith',
    'Shared spiritual growth',
    'Strong family foundation',
  ],
  flexibilitySnapshot: [
    'Open to relocation',
    'Flexible on timeline',
    'Adaptable to life changes',
  ],
}
export function AlignmentSnapshot({
  data = defaultData,
}: AlignmentSnapshotProps) {
  const sections = [
    {
      label: 'Core priorities',
      value: data.corePriorities,
      type: 'list' as const,
    },
    {
      label: 'What Matters Most',
      value: data.whatMatters,
      type: 'list' as const,
    },
    {
      label: 'Flexibility Snapshot',
      value: data.flexibilitySnapshot,
      type: 'list' as const,
    },
  ]
  return (
    <motion.aside
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      transition={{
        duration: 0.8,
        delay: 0.4,
      }}
      className="p-6"
      aria-label="Your alignment snapshot"
    >
      <h2 className="text-xs font-medium text-niyyah-muted uppercase tracking-widest mb-6">
        About You
      </h2>

      <div className="space-y-6">
        {sections.map((section, index) => (
          <motion.div
            key={section.label}
            initial={{
              opacity: 0,
              x: 10,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              duration: 0.5,
              delay: 0.5 + index * 0.1,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            <h3 className="text-xs text-niyyah-muted/70 font-light mb-2">
              {section.label}
            </h3>

            <ul className="space-y-1">
              {(section.value as string[]).map((item, i) => (
                <li
                  key={i}
                  className="text-sm text-niyyah-text font-light flex items-start gap-2"
                >
                  <span className="w-1 h-1 rounded-full bg-niyyah-light/60 mt-2 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>

      {/* Locked indicator */}
      <motion.div
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
        }}
        transition={{
          duration: 0.5,
          delay: 1,
        }}
        className="mt-8 pt-6 border-t border-gray-100"
      >
        <p className="text-xs text-niyyah-muted/50 font-light flex items-center gap-2">
          <svg
            className="w-3 h-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
            />
          </svg>
          Locked for matching
        </p>
      </motion.div>
    </motion.aside>
  )
}